// TODO: Move to marvel-core?
export var STATUS_BAR_TYPE_PROPERTY = 'ui-prj-status-bar';
export var TRIM_STATUS_BAR_PROPERTY = 'ui-prj-remove-status';
export var DEVICE_ORIENTATION = 'ui-prj-orientation';
export var DEVICE_FRAME = 'ui-prj-frame';
export var DEVICE_COLOR = 'ui-prj-frame-colour';
export var DISABLE_SWIPE_THROUGH_SCREENS = 'ui-prj-disable-swipe';
export var DISABLE_HOTSPOT_HINTS = 'ui-prj-show-hints';
export var SCALE_RETINA_IMAGES = 'ui-prj-retina-scale';
